import { render, staticRenderFns } from "./SelectedSlot.vue?vue&type=template&id=4b963f43&scoped=true"
import script from "./SelectedSlot.vue?vue&type=script&lang=js"
export * from "./SelectedSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b963f43",
  null
  
)

export default component.exports